// DS: B0
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Add16 from '@wix/da-ds/pkg/Icons/16x16/Add';
import { useSubmitMenuItem } from '../../../hooks/useSubmitMenuItem';
import { submitButtonMenuItem } from '../../../constants';
import { Url } from '@wix/da-url';
import { isTouch } from '@wix/da-editor-tiptap/pkg/components/utils/browser';

export interface Props {
  id?: string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
}

const SubmitButton: React.FC<Props> = ({ id, className }) => {
  const { t } = useTranslation();
  const {
    href,
    biData,
    onClick: submitOnClick,
  } = useSubmitMenuItem({
    ...submitButtonMenuItem,
    link: Url.studio({ openSubmitForm: true }),
  });

  // This fixes ipads not being able to access the dropdown menu
  const clickHandler = useCallback(
    e => {
      if (submitOnClick) {
        submitOnClick();
        return;
      }
      if (isTouch()) {
        e.preventDefault();
        return;
      }
    },
    [submitOnClick]
  );

  return (
    <BrandedButton
      id={id}
      size="medium"
      variant="brand-green"
      icon={Add16}
      className={className}
      href={href}
      onClick={clickHandler}
      biData={biData}
    >
      {t('siteHeader.submit')}
    </BrandedButton>
  );
};
SubmitButton.displayName = 'SubmitButton';

export default SubmitButton;
